import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

const cleanupStaleWorkers = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
  }
  if ("caches" in window) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
  }
};

if ("requestIdleCallback" in window) {
  (window as Window & typeof globalThis).requestIdleCallback(cleanupStaleWorkers, { timeout: 3000 });
} else {
  setTimeout(cleanupStaleWorkers, 1500);
}
